import './App.css'
import { lazy, Suspense } from 'react';
import {
  Route,
  createRoutesFromElements,
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";


import { Provider } from 'react-redux'
import { store } from '../store'
import Posts from './Posts'
import Container from './Container';
import Home from './Home';
import { DoiPlaceholder } from './DoiPlaceholder';
import { Markdown } from './Markdown';
import ErrorBoundary from './Error';
import { TooltipProvider } from './components/ui/tooltip';

const DetailsView = lazy(() => import('./Details').then(m => ({ default: m.DetailsView })));
const Search = lazy(() => import('./search/Search'));
const SwaggerComponent = lazy(() => import('./swagger/SwaggerUi'));
const SearchContainer = lazy(() => import('./search/SearchContainer'));
const Basket = lazy(() => import('./downloading/Basket').then(m => ({ default: m.Basket })));
const Status = lazy(() => import('./downloading/Status').then(m => ({ default: m.Status })));
const Showcase = lazy(() => import('./cms/Showcase').then(m => ({ default: m.Showcase })));
const Page = lazy(() => import('./cms/Page').then(m => ({ default: m.Page })));
const MapRange = lazy(() => import('./MapRange/MapRange').then(m => ({ default: m.MapRange })));




const routesFromElements = createRoutesFromElements(
  <Route errorElement={<ErrorBoundary />}>
    <Route path="/" errorElement={<ErrorBoundary />} element={<Container><Home /></Container>} />
    <Route path="/posts" element={<Container><Posts /></Container>} />
    <Route path="/results" element={<Container><SearchContainer /></Container>} />
    <Route path="/results/category/:category" element={<Container><Search /></Container>} />
    <Route path="/search/:term" element={<Container><Search /></Container>} />
    <Route path="/results/:identifier" element={<Container><Search /></Container>} />
    <Route path='/showcase/:identifier' element={<Container><Showcase /></Container>} />
    <Route path="/doi/:doi" element={<DoiPlaceholder />} />
    <Route path="/item/:identifier" element={<Container><DetailsView /></Container>} />
    <Route path="/basket" element={<Container><Basket /></Container>} />
    <Route path="/status/:code" element={<Container><Status /></Container>} />
    <Route path="/page/:slug" element={<Container><Page /></Container>} />
    <Route path='/doc/:filename' element={<Markdown />} />
    <Route path='/doc/swagger' element={<SwaggerComponent />} />
    <Route path='/map' element={<MapRange />} />
  </Route>
)


const router = createBrowserRouter(routesFromElements);

export const App = () => {
  return (
    <Provider store={store}>
      <TooltipProvider delayDuration={300} skipDelayDuration={100}>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
          <RouterProvider router={router} />
        </Suspense>
      </TooltipProvider>
    </Provider>
  );
};
